import axios from "axios";
import { message } from 'antd';
const url = process.env.REACT_APP_BACKEND_URL;



export async function getCustomWagersByWagerId(wagerId) {
    return axios({
        method: 'get',
        url: url + "/customWagers?wagerId=" + wagerId
    }).then(res => {
        return res.data;
    });
}
export async function getCustomWagersByBytes32Id(bytes32Id) {
    return axios({
        method: 'get',
        url: url + "/customWagers?bytes32Id=" + bytes32Id
    }).then(res => {
        return res.data;
    });
}

export async function makeCustomWager(
    authToken,
    bytes32Id,
    maker,
    makerETHAddress,
    judge,
    value,
    odds,
    endTime,
    reportingEndTime,
    outcomeOne,
    outcomeTwo,
    makerChoice,
    takerChoice,
    settled,
    cancelled) {

    return axios.post(url + "/customWagers", {
        authToken,
        bytes32Id,
        maker,
        makerETHAddress,
        judge,
        value,
        odds,
        endTime,
        reportingEndTime,
        outcomeOne,
        outcomeTwo,
        makerChoice,
        takerChoice,
        settled,
        cancelled
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });
}

export async function addJudge(authToken, wagerIdValue, judgeAddressValue) {
    return axios({
        method: 'put',
        url: url + "/customWagers/addJudge",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerIdValue, judgeAddress: judgeAddressValue },
    }).then(res => {
        return res.data;
    });
}

export async function takeCustomWager(authToken, takerAddressValue, takerETHAddressValue, wagerIdValue, wagerValueObj) {
    return axios({
        method: 'put',
        url: url + "/customWagers/takeWager",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerIdValue, takerAddress: takerAddressValue, takerETHAddress: takerETHAddressValue, wagerValue: wagerValueObj },
    }).then(res => {
        return res.data;
    });
}

export async function CancelCustomWager(authToken, userIdValue, wagerIdValue, bytes32IdValue) {
    return axios({
        method: 'put',
        url: url + "/customWagers/cancel",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerIdValue, userId: userIdValue, bytes32Id: bytes32IdValue },
    }).then(res => {
        return res.data;
    });
}


export async function submitVote(authToken, wagerIdValue, bytes32IdValue, choiceValue) {
    return axios({
        method: 'put',
        url: url + "/customWagers/vote",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerIdValue, bytes32Id: bytes32IdValue, choice: choiceValue },
    }).then(res => {
        return res.data;
    });
}

export async function submitJudgeVote(authToken, wagerIdValue, bytes32IdValue, choiceValue) {
    return axios({
        method: 'put',
        url: url + "/customWagers/judge-vote",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerIdValue, bytes32Id: bytes32IdValue, choice: choiceValue },
    }).then(res => {
        return res.data;
    });
}

export async function finalizeAbandoned(authToken, wagerId, bytes32Id) {
    return axios({
        method: 'put',
        url: url + "/customWagers/finalize",
        headers: { Authorization: `Bearer ${authToken}` },
        data: { wagerId: wagerId, bytes32Id: bytes32Id },
    }).then(res => {
        return res.data;
    });
}


// WEBPACK FOOTER //
// ./src/api-calls/customWagers.js